<style>

.card{
  position: relative;
  color: white;
}

img{
  object-fit: cover;
  width: 100%;
}

.name{
  font-size: 24px;
  /* text-align: center; */
  margin: 10px 20px 0 20px;
}
.common-interests{
  /* text-align: center; */
  margin: 0 20px 10px 20px;
  font-size: 18px;
}

.bio{
  margin: 20px;
}

.my-interests{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 20px;
}
.my-interests-text{
  margin: 20px;
}

.message-friends-buttons{
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 20px 0;
}
.message{
  grid-column: 1;
  padding: 0 10px;
}
.friends{
  grid-column: 2;
  padding: 0 10px;
  text-align: right;
}

button{
  border-radius: 15px;
  border-width: 1px;
  padding: 10px 20px;
}
.photos{
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.a-photo{
  width: 100px;
  height: 100px;
  background-image: url('/i/horse_backriding.jpg');
  background-color: gray;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  margin: 5px;
}

.upcoming{
  font-family: Sansation;
  font-size: 14px;
  font-style: italic;
  margin: 20px;
}

.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
}
.info{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
}

.friend-buttons{
  margin-bottom: 10px;
}
button.edit{
  border-radius: 5px;
  border-width: 1px;
  padding: 10px 20px;
  background-color: rgba(255,255,255,0.6);
  border: 1px gray solid;
  color: black;
}
button.edit:hover{
  background-color: white;
}
</style>

<Dialog show="{editFriendStatus}" title="Friends" close="{false}" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, } ] }" on:done="{ () => editFriendStatus = false }" on:close="{ () => editFriendStatus = false }">
  <div class="friend-buttons"> <button class="edit" on:click="{unfriend}"> <i class="icon-person_remove"></i> Unfriend</button> </div>
  <div> <button class="edit" on:click="{block}"> <i class="icon-block"></i> Block</button> </div>
</Dialog>

<Dialog show="{unfriendShow}" title="Unfriend?" close="{false}" buttons="{ [ {text: 'No', callback: 'close', disabled: false, }, {text: 'Yes', callback: 'yes', disabled: false, }  ] }" on:close="{ () => unfriendShow = false }" on:yes="{unfriendNow}">
  Are you sure you want to unfriend Rose Alibaster?
</Dialog>

<Dialog show="{blockShow}" title="Block?" close="{false}" buttons="{ [ {text: 'No', callback: 'close', disabled: false, }, {text: 'Yes', callback: 'yes', disabled: false, }  ] }" on:close="{ () => blockShow = false }" on:yes="{blockNow}">
  Are you sure you want to block Rose Alibaster?
</Dialog>


<Header 
back="{true}"
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, ] }"
on:addEvent="{ () => push('/create-new-event') }"
on:back="{ () => { pop() } }">Friend Profile</Header>
<div class="has-header"></div>

<img src="/i/rose-alibaster.jpg" alt="" class="img">

<div class="name">{name}</div>
<div class="common-interests">Common Interests: {commonInterests}%</div>

<div class="bio">{bio}</div>

<div class="my-interests">My Interests</div>
<div class="my-interests-text">
  Hiking<br>
  Smelling roses<br>
  Moon landings<br>
</div>

<div class="message-friends-buttons">
  <div class="message"> <button on:click="{ () => push('/message/'+params.oid) }"> Message </button> </div>
  <div class="friends"> <button on:click="{ () => editFriendStatus = true }"> <i class="icon-check"></i> Friends </button> </div>
</div>

<div class="photos">
  <div class="a-photo"></div>
  <div class="a-photo"></div>
  <div class="a-photo"></div>
</div>

<div class="upcoming">Rose's Upcoming Events:</div>

<div class="card">
  <img src="/i/rose-alibaster-event01.jpg" alt="" class="img">
  <div class="starts-in"><StartsIn currentTime="{currentTime}" startsAt="{eventStartsAt}" endsAt="{eventEndsAt}"></StartsIn></div>
  
  <div class="info">
    <div class="event-name">{eventName}</div>
    <div><Stars stars="{eventStars}"></Stars></div>
    <div><EventTime startsAt="{eventStartsAt}" endsAt="{eventEndsAt}"></EventTime></div>
  </div>
</div>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Header from "../components/Header.svelte";
import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";
import Dialog from "../components/Dialog.svelte";

let username = "@alison93";
let name = "Rose Alibaster";
let birthday = "02/21/1983";
let bio = "I love smelling roses.  My name is Rose, so that should be no surprise.  What is surprising is that I love moon landings...";
let commonInterests = 89;
let editFriendStatus = false;
let unfriendShow = false;
let blockShow = false;

let date = Math.round( Date.now() / 1000 );
let currentTime =  Math.round( Date.now() / 1000 );

let eventName = "Whatever this is?!";
let eventStars = 3.5;
let eventStartsAt = date + (3600 * 24);
let eventEndsAt = date + (3600 * 25);

function editFriendStatusDone() {
  
}


function unfriend() {
  editFriendStatus = false;
  unfriendShow = true;
}


function block() {
  editFriendStatus = false;
  blockShow = true;
}


function unfriendNow() {
  replace('/friends');
}

function blockNow() {
  replace('/friends');
}

</script>